<template>
  <div class="common_herder bgcolor">
    <div class="content">
      <img src="../assets/img/logo.png" alt="" srcset="" />
      <div class="right_box">
        <div class="phone-info">
          <strong class="cFFFFFF">TITAN FREIGHT FORWARDING CO., LTD</strong>
        </div>
        <ul class="ul_list">
          <li class="menu-item">
            <a itemprop="url" tabindex="0" @click="$router.push('/home')"
              ><span class="avia-menu-text cFFFFFF">Home</span></a
            >
          </li>
          <li class="menu-item">
            <a itemprop="url" tabindex="0" @click="$router.push('/about_us')"
              ><span class="avia-menu-text cFFFFFF">About us</span></a
            >
          </li>
          <li
            class="menu-item"
            @mousemove="tabIndex = 3"
            @mouseleave="tabIndex = null"
          >
            <a @click="$router.push('/AIR_FREIGHT')" itemprop="url" tabindex="0"
              ><span class="avia-menu-text cFFFFFF">Services</span></a
            >
            <div
              class="menu_box_list"
              :class="tabIndex == 3 ? 'opcity1' : 'opcity0'"
            >
              <ul>
                <li @click="$router.push('/AIR_FREIGHT')">Air Freight</li>
                <li @click="$router.push('/sea_freight')">Sea Freight</li>
                <li @click="$router.push('/Courier')">Courier Services</li>
                <li @click="$router.push('/Container_Wharf_Transport')">
                  Container & Wharf Transport
                </li>
                <li @click="$router.push('/Warehousing')">
                  Warehousing Solutions
                </li>
              </ul>
            </div>
          </li>
          <li class="menu-item">
            <a @click="$router.push('/projects')" itemprop="url" tabindex="0"
              ><span class="avia-menu-text cFFFFFF">Projects</span></a
            >
          </li>
          <li class="menu-item">
            <a @click="$router.push('/contact_us')" itemprop="url" tabindex="0"
              ><span class="avia-menu-text cFFFFFF">Contact us</span></a
            >
          </li>
          <li class="menu-item">
            <i
              class="el-icon-search icon_li"
              @click.stop="isShowINput = !isShowINput"
              color="#FFFFFF"
            >
            </i>
            <div class="avia-search-tooltip" v-if="isShowINput">
              <div class="inner_tooltip">
                <div class="box">
                  <input type="text" placeholder="Seach" />
                  <span>
                    <i class="el-icon-search" color="#FFFFFF"> </i>
                  </span>
                </div>
              </div>
              <span class="avia-arrow-wrap"
                ><span class="avia-arrow"></span
              ></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "common_herder",
  data() {
    return {
      isShowINput: false,
      tabIndex: null,
    };
  },
  created() {
    window.addEventListener("click", this.clickOther);
  },
  methods: {
    clickOther(e) {
      if (e.target["offsetParent"]["_prevClass"] == "avia-search-tooltip") {
        this.isShowINput = true;
        return;
      }
      this.isShowINput = false;
    },
  },
  destroyed() {
    window.removeEventListener("click", this.clickOther);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
.common_herder {
  .herder_top {
    max-width: 1310px;
    display: flex;
    align-items: flex-end;
    justify-content: right;
    padding: 0 50px;
    margin: 0 auto;
    height: 30px;
    .ul_list {
      display: flex;
      align-items: center;
      // margin-top: 40px;
      li {
        &:first-child {
          border-right: 1px solid #ffffff;
        }
        a > span {
          font-size: 16px;
          padding: 0 10px;
          display: inline-block;
        }
      }
    }
  }
  .content {
    z-index: 44;
    display: flex;
    align-items: start;
    justify-content: space-between;
    max-width: 1310px;
    padding: 0 50px;
    margin: 0 auto;
    height: 140px;
    img {
      width: 100px;
      height: auto;
      margin-top: 20px;
    }
    .right_box {
      .phone-info {
        text-align: right;
        margin-top: 30px;
        font-size: 32px;
        span {
          a {
            font-size: 22px;
          }
        }
        strong {
          font-size: 32px;
        }
      }
      .ul_list {
        display: flex;
        align-items: center;
        justify-content: end;
        margin-top: 0px;
        height: 76px;
        .menu-item {
          height: 76px;
          list-style: none;
          padding: 0 13px;
          position: relative;
          display: flex;
          align-items: center;
          cursor: pointer;
          justify-content: center;
          .icon_li {
            color: #ffffff !important;
            cursor: pointer;
          }
          .avia-search-tooltip {
            position: absolute;
            right: 0;
            top: 65px;
            z-index: 100000;
            border: 1px solid #c9c9c9;
            box-shadow: 0px 3px 13px 0px rgba($color: #000000, $alpha: 0.2);
            .avia-arrow-wrap {
              width: 20px;
              height: 6px;
              position: absolute;
              top: -6px;
              right: 10px;
              margin-left: -10px;
              overflow: hidden;
              .avia-arrow {
                height: 20px;
                width: 9px;
                position: absolute;
                top: 0;
                left: 50%;
                margin-left: -5px;
                -webkit-transform: rotate(45deg);
                transform: rotate(45deg);
                border-width: 1px;
                border-style: solid;
                background-color: rgb(227, 69, 48);
                color: #c9c9c9;
              }
            }
            .inner_tooltip {
              background-color: rgb(227, 69, 48);
              color: #c9c9c9;
              padding: 16px;
              .box {
                // width: 266px;
                height: 42px;
                background: #f8f8f8;
                display: flex;
                align-items: center;
                input {
                  padding: 12px 47px 12px 5px;
                  background: transparent;
                  outline: none;
                }
                span {
                  width: 40px;
                  background: transparent;
                  height: 42px;
                  display: inline-block;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  i {
                    color: #333333;
                    cursor: pointer;
                  }
                }
              }
            }
          }
          &:hover {
            a > span {
              color: #ffeb3d;
              border-left-color: #ffffff;
            }
          }
          &:first-child {
            a {
              span {
                border-left: none;
              }
            }
          }
          a {
            span {
              font-size: 16px;
              border-left-style: solid;
              border-left-color: #ffffff;
              border-left-width: 1px;
              padding-left: 13px;
              display: inline-block;
              margin-left: -13px;
            }
            .avia-menu-text2 {
              background-color: #ffeb3d !important;
              color: #1c2c6c !important;
              border: 2px solid #ffeb3d;
              border-width: 2px;
              padding: 9px;
              margin-left: -13px;
              display: inline-block;
              border-left: none;
              border-radius: 2px;
              &:hover {
                box-shadow: 0 13px 90px rgba($color: #000000, $alpha: 0.1) inset;
                opacity: 0.96;
                transition: all 0.6s;
              }
            }
          }
          .opcity1 {
            opacity: 1;
            transform: all 6s;
          }
          .opcity0 {
            opacity: 0;
            transform: all 6s;
          }
          .menu_box_list {
            position: absolute;
            top: 76px;
            left: 0;
            z-index: 10000;
            background-color: rgb(227, 69, 48);
            border: 1px solid #ffffff;
            border-top: none;
            width: 100%;
            min-width: 208px;
            box-shadow: 0 8px 15px rgba($color: #000000, $alpha: 0.1);
            li {
              padding: 10px 15px;
              color: #eeebeb;
              cursor: pointer;
              font-size: 16px;
              &:hover {
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue